import Vue from "vue";


/**
 * 从字符串模板中，按字段名替换 {} 
 * 
 * @param {*} template 
 * @param {*} data 
 * @returns 
 */
export function replaceMe(template, data) {
    const pattern = /{\s*(\w+?)\s*}/g; // {property}
    return template.replace(pattern, (_, token) => {
        if (data.hasOwnProperty(token)) {
            return data[token];
        } else if (data.fields){
            const field = data.fields.find(f => f.name === token);
            if (field) {
                return field.value;
            }
        }
        
        return `{${token}}`
    });
}

export function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function increment(str) {
    const num = parseInt(str);
    if (isNaN(num)) {
        return str;
    } else {
        return '' + (num+1);
    }
}

export function incrementAll(obj) {
    for (const key in obj) {
        const value = obj[key];
        obj[key] = increment(value);
    }
}

/**
 * 将选项数组，按照 value 进行过滤，保留 filterValues 中有值的元素
 * const options = 
 * [
 *   {
 *     value:'1',
 *     label: 'option 1'
 *   },
 *   {
 *     value:'2',
 *     label: 'option 2'
 *   }
 * ]
 * 
 * const filterValues = ['100', '144']
 * 
 * @param {*} options 
 * @param {*} filterValues 
 * @returns 
 */
export function filterOptions(options, filterValues) {
    // const newOptions = [];
    // for (const value of filterValues) {
    //     const option = options.find(o => o.value === value);
    //     if (option) {
    //         newOptions.push(...option);
    //     }
    // }
    // return newOptions;
    return options.filter(o => filterValues.includes(o.value));
}



export function clearAllSignals(state, ip) {
    ip.pins.forEach(p => {
        const pin = state.chip.pins[p.position - 1];
        Vue.delete(pin, 'signal');
        Vue.delete(pin, 'ip');

        // pin.signal = '';
        // pin.ip = '';
    });

    const length = ip.pins.length;
    ip.pins.splice(0, length);
}

export function clearPinSignal(state, ip, signal) {
    const signalName = ip.instance + '_' + signal;
    const pinIndex = ip.pins.findIndex(p => p.signal === signalName)
    if (pinIndex > -1) {
        const pin = ip.pins[pinIndex];
        const chipPin = state.chip.pins[pin.position - 1];
        Vue.delete(chipPin, 'signal');
        Vue.delete(chipPin, 'ip');

        ip.pins.splice(pinIndex, 1);

        if (state.pinIndex >= ip.pins.length) {
            state.pinIndex = ip.pins.length - 1;
        }
    }
}

export function getCurrentIP(state) {
    let ipIndex = state.ipIndex;
    if (state.chip.ips) {
        if (ipIndex < state.chip.ips.length) {
            return state.chip.ips[ipIndex];
        }
    }
}

/**
 * 从 pins 数组中，找到一个有 signal 的元素
 * 
 * @param {*} pins 
 * @param {*} signal 
 * @returns 
 */
export function findPinBySignal(pins, signal) {
    return pins.find(p => {
        if (p.type === 'I/O') {
            if (!p.hasOwnProperty('signal') || p.signal === '') {
                return p.signals && p.signals.some(s => s.name === signal)
            }
        }

        return false;
    }
    );
}

/**
 * 计算文件大小字符串
 * 
 * @param {*} bytes 
 * @param {*} decimalPoint 
 * @returns 
 */
export function formatSize(bytes, decimalPoint) {
   if(bytes == 0) return '0 Bits/s';
   var k = 1000,
       dm = decimalPoint || 1,
       sizes = ['Bits/s', 'KBits/s', 'MBits/s', 'GBits/s', 'TBits/s', 'PBits/s'],
       i = Math.floor(Math.log(bytes) / Math.log(k));
   return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}